<template>
  <div class="error-page">
    <a href="/index">
      <div class="error-logo">
        <img class="img" src="../assets/logo@2x.png" alt="" data-track-text="首页Logo" aria-label="首页Logo" style="cursor: pointer" @click="toIndex">
      </div>
    </a>
    <img class="error-background" src="../assets/500bg.png" alt="">
    <div class="error-message" style="width: 330px;text-align: center;
        height: 76px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        line-height: 48px;
       "><span>哎呀，页面无法显示了，我们在努力寻找中...</span>
    </div>
    <a href="/index">
      <div class="error-back" style="width: 160px;
      text-align: center;
        height: 45px;
        border: 1px solid #1C50A7;
        border-radius: 6px;
        position: absolute;
        margin-top: 440px;
        margin-left: 360px;
        " data-track-text="错误页返回首页" aria-label="错误页返回首页" @click="">
        <span style="width: 72px;
          height: 18px;
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #1C50A7;
          line-height: 45px;
          ">
          返回首页
        </span>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: "Error"
  }
</script>

<style scoped>
.error-page {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background: #f3f7fb;
}

.error-background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.error-logo {
  position: absolute;
  z-index: 1;
  top: 20px;
  left: max(24px, calc((100% - 1200px) / 2));
}

.error-message {
  position: absolute;
  z-index: 1;
  top: 34%;
  left: max(24px, calc((100% - 1200px) / 2 + 100px));
  margin: 0 !important;
}

.error-back {
  position: absolute !important;
  z-index: 1;
  top: calc(34% + 140px);
  left: max(24px, calc((100% - 1200px) / 2 + 130px));
  margin: 0 !important;
}

@media (max-width: 768px) {
  .error-logo {
    top: 14px;
    left: 14px;
  }

  .error-logo .img {
    max-width: 96px;
    height: auto;
  }

  .error-message {
    top: 32%;
    right: 24px;
    left: 24px;
    width: auto !important;
    height: auto !important;
    font-size: 22px !important;
    line-height: 34px !important;
  }

  .error-back {
    top: calc(32% + 135px);
    left: 50%;
    transform: translateX(-50%);
  }
}

</style>
